import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const videos = [
  '/assets/videos/banner1.mp4',
  '/assets/videos/banner2.mp4',
  '/assets/videos/banner3.mp4',
];

function VideoSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % videos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-[70vh] overflow-hidden">
      {videos.map((video, index) => (
        <motion.video
          key={index}
          src={video}
          autoPlay
          loop
          muted
          className={`absolute top-0 left-0 w-full h-full object-cover ${index === current ? 'opacity-100' : 'opacity-0'}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: index === current ? 1 : 0 }}
          transition={{ duration: 1 }}
        />
      ))}
      <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-center text-white"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Engineering the Future</h1>
          <p className="text-lg md:text-xl">Innovative Structural Solutions for a Sustainable World</p>
        </motion.div>
      </div>
    </div>
  );
}

export default VideoSlider;